export default __webpack_public_path__ + "static/media/best_wallet.10a7b21f.svg";